<div class="space-y-6">

  <!-- Header -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h2 class="text-2xl font-semibold text-gray-800">Support Tickets</h2>
      <p class="text-sm text-gray-500 mt-1">Manage and resolve user issues.</p>
    </div>
    <div class="flex gap-3">
        <button
          (click)="loadTickets()"
          class="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg hover:bg-gray-200 transition">
          Refresh
        </button>
        <button
          (click)="openCreateModal()"
          class="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition">
          + Create Ticket
        </button>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && errorMessage" class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
    <span>{{ errorMessage }}</span>
    <button (click)="loadTickets()" class="ml-auto text-sm underline">Retry</button>
  </div>

  <!-- Data Grid -->
  <div *ngIf="!isLoading && !errorMessage" class="bg-white rounded-2xl shadow overflow-hidden">
    <table class="w-full text-sm">
      <thead class="bg-gray-100 text-left">
        <tr>
          <th class="p-4">Ticket ID</th>
          <th class="w-1/3">Subject</th>
          <th>Priority</th>
          <th>Created At</th>
          <th>Status</th>
          <th>Update Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ticket of tickets" class="border-t hover:bg-gray-50">
          <td class="p-4 font-medium text-gray-800">#{{ ticket.id }}</td>
          <td>
             <p class="font-semibold text-gray-800">{{ ticket.subject }}</p>
             <p class="text-xs text-gray-500 mt-1 truncate max-w-sm">{{ ticket.description }}</p>
          </td>
          <td class="capitalize" [ngClass]="getPriorityClass(ticket.priority)">
             {{ ticket.priority }}
          </td>
          <td class="text-gray-600">{{ ticket.created_at | date:'mediumDate' }}</td>
          <td>
            <span [ngClass]="getBadgeColorClass(ticket.status)" class="px-2 py-1 rounded-full text-xs font-medium capitalize border">
              {{ ticket.status.replace('_', ' ') }}
            </span>
          </td>
          <td>
             <div class="flex items-center gap-2 pr-4">
                <select 
                    [ngModel]="ticket.status" 
                    (ngModelChange)="updateStatus(ticket, $event)"
                    [disabled]="updatingTicketId === ticket.id"
                    class="w-full border border-gray-300 rounded-lg px-2 py-1 text-xs outline-none focus:ring-2 focus:ring-blue-500 bg-white">
                   <option value="open">Open</option>
                   <option value="in_progress">In Progress</option>
                   <option value="resolved">Resolved</option>
                   <option value="closed">Closed</option>
                </select>
                <div *ngIf="updatingTicketId === ticket.id" class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
             </div>
          </td>
        </tr>
        <tr *ngIf="tickets.length === 0">
          <td colspan="6" class="p-8 text-center text-gray-500">No support tickets found.</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

<!-- Modal Form -->
<app-modal [isOpen]="isModalOpen" (close)="isModalOpen = false" className="max-w-2xl">
    <app-ticket-form 
        *ngIf="isModalOpen"
        [users]="users"
        (save)="handleSave($event)" 
        (cancel)="isModalOpen = false">
    </app-ticket-form>
</app-modal>
